import { ChatAction, ChatMessage } from "src/common/models/chat";
import { SystemDescriptions } from "src/common/descriptions";
import * as Actions from "./action";
import * as ActionTypes from "./actionTypes";

export interface ChatState {
    messages: ChatMessage[]
    lastToolsUsed: string[]
    activeQuotation?: {
        quotationId: number
        quotationCode?: string
        documentType?: string
        name?: string
        customerName?: string
    }
    error?: any
}

const initialState: ChatState = {
    messages: [],
    lastToolsUsed: [],
}

const chatReducer = (state: ChatState = initialState, action: any): ChatState => {
    switch (action.type) {
        case ActionTypes.CLEAN_CHAT:
            return initialState
        case ActionTypes.SEND_CHAT_MESSAGE_API: {
            const requestAction = action as Actions.SendChatMessageAction
            return {
                ...state,
                error: undefined,
                messages: [
                    ...state.messages,
                    {
                        role: "user",
                        content: requestAction.request.message,
                    },
                ],
            }
        }
        case ActionTypes.SEND_CHAT_MESSAGE_API_SUCCESS: {
            const successAction = action as Actions.SendChatMessageSuccessAction
            const activeQuotationAction = (successAction.response.actions || [])
                .find((chatAction: ChatAction) => chatAction.type === "SET_ACTIVE_QUOTATION")
            return {
                ...state,
                activeQuotation: activeQuotationAction
                    ? {
                        quotationId: activeQuotationAction.payload.quotationId,
                        quotationCode: activeQuotationAction.payload.quotationCode,
                        documentType: activeQuotationAction.payload.documentType,
                        name: activeQuotationAction.payload.name,
                        customerName: activeQuotationAction.payload.customerName,
                    }
                    : state.activeQuotation,
                lastToolsUsed: successAction.response.toolsUsed || [],
                messages: [
                    ...state.messages,
                    {
                        role: "assistant",
                        content: successAction.response.response,
                        toolsUsed: successAction.response.toolsUsed || [],
                        actions: successAction.response.actions || [],
                    },
                ],
            }
        }
        case ActionTypes.SEND_CHAT_MESSAGE_API_ERROR: {
            return {
                ...state,
                error: undefined,
                messages: [
                    ...state.messages,
                    {
                        role: "error",
                        // Never expose a transport or server error in the chat transcript.
                        content: SystemDescriptions.PAGES.CHAT.REQUEST_ERROR,
                    },
                ],
            }
        }
        default:
            return state
    }
}

export default chatReducer
